{
  "common": {
    "ok": "OK",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "loading": "Loading...",
    "error": "Error",
    "info": "Information",
    "success": "Success",
    "back": "Back",
    "send": "Send",
    "sending": "Sending...",
    "search": "Search",
    "accept": "Accept",
    "reject": "Reject",
    "confirm": "Confirm",
    "online": "Online",
    "you": "You",
    "noMessages": "No messages yet",
    "adminPanelDesktopOnly": "Panneau indisponible sur mobile",
    "adminPanelDesktopOnlyHint": "Les panneaux admin et organisateur sont disponibles sur tablette et ordinateur.",
    "networkError": "We couldn't load the data.",
    "networkErrorHint": "Check your connection and try again.",
    "retry": "Retry",
    "myQrCode": "My QR code",
    "myQrPill": "Mon QR",
    "hideQrPill": "Masquer Mon QR",
    "showQrPill": "Afficher Mon QR",
    "today": "Aujourd'hui",
    "tomorrow": "Demain"
  },
  "auth": {
    "login": {
      "title": "Welcome back!",
      "subtitle": "Sign In",
      "credentialsHint": "Enter your credentials to continue",
      "email": "Email",
      "emailPlaceholder": "your@email.com",
      "password": "Password",
      "passwordPlaceholder": "••••••••",
      "loading": "Signing in...",
      "button": "Sign In",
      "forgotPassword": "Forgot your password?",
      "forgotPasswordSoon": "Coming soon",
      "forgotPasswordMessage": "Password recovery will be available soon.",
      "continueWith": "or continue with",
      "noAccount": "Don't have an account?",
      "createAccount": "Create account",
      "errors": {
        "emailNotConfirmed": "We couldn’t sign you in.\n\nIf you just created your account, please try again in a few seconds.",
        "loginError": "Sign in error",
        "unexpectedError": "An unexpected error occurred. Please try again."
      }
    },
    "register": {
      "title": "Join BIAVENT!",
      "subtitle": "Create Account",
      "email": "Email",
      "emailPlaceholder": "your@email.com",
      "password": "Password",
      "confirmPassword": "Confirm Password",
      "loading": "Creating account...",
      "button": "Create Account",
      "continueWith": "or continue with",
      "hasAccount": "Already have an account?",
      "loginLink": "Sign in",
      "success": {
        "title": "✅ Account created successfully!",
        "message": "You can sign in now. Let’s complete your profile."
      },
      "errors": {
        "createError": "Error creating account",
        "unexpectedError": "Unexpected error"
      }
    },
    "logout": {
      "button": "Sign Out",
      "confirm": "Are you sure you want to sign out?"
    },
    "forgotPassword": {
      "title": "Password recovery",
      "subtitle": "Reset your password",
      "description": "Enter your email address and we will send you a link to reset your password.",
      "email": "Email",
      "emailPlaceholder": "your@email.com",
      "loading": "Sending...",
      "button": "Send reset link",
      "backToLogin": "Back to sign in",
      "success": {
        "title": "Check your email",
        "message": "If an account exists with that email, you will receive a link to reset your password."
      },
      "errors": {
        "unexpectedError": "An unexpected error occurred. Please try again."
      }
    },
    "resetPassword": {
      "title": "New password",
      "subtitle": "Choose a new password",
      "description": "Enter and confirm your new password.",
      "password": "New password",
      "passwordPlaceholder": "••••••••",
      "confirmPassword": "Confirm password",
      "confirmPasswordPlaceholder": "••••••••",
      "loading": "Updating...",
      "button": "Update password",
      "backToLogin": "Back to sign in",
      "requirements": {
        "minLength": "At least 8 characters",
        "lowercase": "At least one lowercase letter",
        "uppercase": "At least one uppercase letter",
        "number": "At least one number",
        "symbol": "At least one symbol"
      },
      "success": {
        "title": "Password updated",
        "message": "Your password has been updated successfully."
      },
      "invalidLink": {
        "title": "Invalid or expired link",
        "message": "This password reset link is invalid or has expired. Please request a new one.",
        "cta": "Request new link"
      },
      "errors": {
        "unexpectedError": "An unexpected error occurred. Please try again."
      }
    }
  },
  "onboarding": {
    "personalInfo": {
      "title": "Personal Information",
      "subtitle": "Complete your basic profile",
      "firstName": "First name",
      "lastName": "Last name",
      "phone": "Phone",
      "email": "Email",
      "placeholderFirstName": "Your name",
      "placeholderLastName": "Your last name",
      "placeholderPhone": "+34 600 000 000",
      "placeholderEmail": "your@email.com",
      "continue": "Continue",
      "errorFirstName": "First name is required",
      "errorLastName": "Last name is required",
      "errorPhone": "Please enter a valid phone number",
      "errorEmail": "Please enter a valid email"
    },
    "socialNetworks": {
      "title": "Social Networks (Choose one or more)",
      "linkedin": "LinkedIn",
      "instagram": "Instagram",
      "twitter": "X (Twitter)",
      "youtube": "YouTube",
      "tiktok": "TikTok",
      "placeholderLinkedin": "https://linkedin.com/in/your-profile",
      "placeholderInstagram": "https://instagram.com/your-user",
      "placeholderTwitter": "https://twitter.com/your-user",
      "placeholderYoutube": "https://youtube.com/@your-channel",
      "placeholderTiktok": "https://tiktok.com/@your-user",
      "errorInvalid": "Please enter a valid URL"
    },
    "welcomeQuestion": {
      "title": "What do you do?",
      "subtitle": "Your answer will help us generate networking keywords and suggest relevant connections within the event.",
      "placeholder": "E.g.: I'm a frontend developer, I work in digital marketing, I'm an entrepreneur...",
      "continue": "Continue",
      "back": "Back",
      "loading": "Processing...",
      "error": "We couldn't process your response. Please try again.",
      "errorEmpty": "Write something about yourself to continue"
    }
  },
  "appTour": {
    "replayButton": "Voir le tutoriel à nouveau",
    "welcome": {
      "title": "Bienvenue sur Biavent !",
      "subtitle": "Un court tour des essentiels pour bien démarrer.",
      "start": "Commencer le tour",
      "skip": "Passer pour l'instant"
    },
    "controls": {
      "prev": "Précédent",
      "next": "Suivant",
      "skip": "Passer le tutoriel",
      "close": "Fermer",
      "done": "Terminer",
      "progress": "{{current}} sur {{total}}",
      "tapHere": "Appuyez ici"
    },
    "steps": {
      "navOverview": {
        "title": "Navigation",
        "body": "Accédez aux sections principales de l'app ici."
      },
      "eventsHome": {
        "title": "Vos événements",
        "body": "Consultez les événements à venir et votre accueil personnalisé."
      },
      "eventsDiscover": {
        "title": "Explorer les événements",
        "body": "Tous les événements apparaissent ici."
      },
      "navNetworking": {
        "title": "Networking",
        "body": "Appuyez ici pour les connexions et les chats."
      },
      "networkingHub": {
        "title": "Activité et connexions",
        "body": "Gérez demandes, contacts et conversations."
      },
      "navProfile": {
        "title": "Votre profil",
        "body": "Appuyez pour voir et modifier votre profil professionnel."
      },
      "profileComplete": {
        "title": "Profil complet",
        "body": "Plus vous complétez votre profil, meilleures recommandations nous pouvons vous offrir."
      },
      "qrEssential": {
        "title": "Votre code QR",
        "body": "Montrez votre QR aux événements pour vous connecter."
      }
    }
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Manage your preferences",
    "appearance": {
      "title": "Appearance",
      "theme": {
        "label": "Theme",
        "auto": "Automatic (like device)",
        "light": "Light",
        "dark": "Dark",
        "description": "Choose how you want the app to look"
      }
    },
    "language": {
      "title": "Language",
      "label": "Language",
      "auto": "Automatic (according to device)",
      "description": "Choose the app language",
      "detected": "Détecté"
    },
    "appTour": {
      "title": "Tutoriel de l'app",
      "description": "Revoir le tour guidé des fonctionnalités principales.",
      "replay": "Voir le tutoriel à nouveau"
    },
    "notifications": {
      "title": "Notifications",
      "subtitle": "Manage your push notification preferences"
    },
    "dataAndCache": {
      "title": "Data & cache",
      "description": "Refresh cached data or reload the app to see the latest information or fix loading issues.",
      "refreshData": "Refresh data",
      "clearAndReload": "Clear cache and reload",
      "refreshSuccess": "Cache cleared. New data will load when you navigate.",
      "reloading": "Reloading..."
    }
  },
  "events": {
    "title": "Events",
    "greeting": "Hello",
    "upcomingEvent": "upcoming event",
    "upcomingEvents": "upcoming events",
    "noUpcoming": "No upcoming events",
    "recommendationHint": "To receive personalized attendee recommendations, register for the events that interest you.",
    "recommendationHintShort": "Inscrivez-vous aux événements pour des recommandations personnalisées.",
    "loading": "Loading events...",
    "hidePast": "Hide past events",
    "showPast": "Show past events",
    "noEvents": "No events",
    "noEventsMessage": "There are no events scheduled at the moment. Come back soon to discover new connection and learning opportunities.",
    "live": "LIVE",
    "registered": "Registered",
    "full": "Full",
    "register": "Register",
    "sectionUpcoming": "Upcoming events",
    "sectionPast": "Past events",
    "filterAll": "All",
    "filterRegistered": "Registered",
    "filterPast": "Past",
    "upcomingBadge": "Upcoming",
    "participants": {
      "zero": "0 participants",
      "one": "1 participant",
      "many": "{count} participants"
    },
    "capacity": {
      "full": "Complet ({max}/{max})",
      "oneLeft": "{current}/{max} places (1 disponible)",
      "available": "{current}/{max} places ({available} disponibles)"
    }
  },
  "eventDetail": {
    "loading": "Loading event...",
    "notFound": "Event not found",
    "backToEvents": "Back to events",
    "back": "Back",
    "live": "LIVE",
    "description": "Description",
    "registration": {
      "title": "Registration",
      "subtitle": "Reserve your spot and receive all the information you need to participate.",
      "full": "Event full ({max}/{max} spots)",
      "capacity": "{count}/{max} spots taken ({available} available)",
      "limitedSeats": "Limited spots: confirm your attendance to secure your place.",
      "pastEvent": "This event has already taken place. Check the calendar for new ones.",
      "alreadyRegistered": "You are already registered and will receive event updates.",
      "unregisterLoading": "Cancelling registration...",
      "unregister": "Unregister from event",
      "eventFull": "This event is full. No spots available.",
      "registerLoading": "Saving your spot...",
      "registerButton": "Register for event",
      "checkingRegistration": "Checking if you are already registered...",
      "loadingProfile": "Loading your profile to enable registration...",
      "registeredTitle": "Vous êtes inscrit !",
      "registeredEmailHint": "Nous vous enverrons toutes les informations par e-mail"
    },
    "registrationGoal": {
      "title": "Quel est votre objectif pour cet événement ?",
      "subtitle": "Dites-nous ce que vous recherchez dans \"{eventTitle}\" pour vous recommander des personnes aux intérêts alignés.",
      "placeholder": "Ex. : Réseauter avec des développeurs, chercher des investisseurs, apprendre de nouvelles technologies...",
      "submit": "M'inscrire et calculer les matchs ✨",
      "saveObjective": "Enregistrer l'objectif ✨",
      "profileSaveError": "Impossible d'enregistrer votre objectif. Réessayez.",
      "error": "Veuillez écrire un objectif pour mieux vous aider à vous connecter.",
      "tagsTitle": "Suggestions rapides (vous pouvez en choisir plusieurs) :",
      "tag1": "🤝 Trouver des associés ou collaborateurs",
      "tag2": "💼 Chercher des opportunités d'affaires",
      "tag3": "✨ Réseauter et créer des contacts",
      "tag4": "📚 Apprendre et acquérir des connaissances",
      "tag5": "🚀 Rencontrer des personnes du secteur"
    },
    "tabs": {
      "agenda": "Agenda",
      "speakers": "Speakers",
      "recommendations": "Recommendations",
      "notifications": "Notifications",
      "location": "Location"
    },
    "agenda": {
      "title": "Agenda",
      "noAgenda": "No agenda available for this event."
    },
    "speakers": {
      "title": "Speakers",
      "noSpeakers": "No speakers registered for this event."
    },
    "recommendations": {
      "recommended": "Recommended",
      "allAttendees": "All attendees",
      "title": "Recommended People",
      "subtitle": "People registered for the event who might interest you.",
      "calculating": "Calculating recommendations...",
      "noRecommendations": "No recommendations available at the moment.",
      "attendeesTitle": "Event attendees",
      "attendeesSubtitle": "People who have already confirmed their attendance.",
      "loadingAttendees": "Loading attendees...",
      "beFirst": "Be the first person to register for the event.",
      "connect": "Connect",
      "requestSent": "Request sent",
      "openChat": "Open chat"
    },
    "notifications": {
      "title": "Event Notifications",
      "loading": "Loading notifications...",
      "noNotifications": "No notifications for this event.",
      "noNotificationsHint": "Notifications related to this event will appear here.",
      "now": "Now",
      "minutesAgo": "{mins} min ago",
      "hoursAgo": "{hours} h ago",
      "daysAgo": "{days} d ago",
      "eventNotification": "Event notification",
      "noMessage": "No message",
      "new": "New",
      "markAsRead": "Mark as read"
    },
    "location": {
      "title": "Location",
      "openInMaps": "Open in Google Maps",
      "notAvailable": "Location not available",
      "howToArrive": "How do you want to get there?",
      "byCar": "By car",
      "byTransit": "Public transport",
      "byBicycle": "By bicycle",
      "byWalking": "Walking",
      "gettingLocation": "Getting your location...",
      "cantCalculate": "Cannot calculate route without a valid location."
    },
    "errors": {
      "profileNotFound": "We could not identify your profile. Reload the page and try again.",
      "registrationFailed": "We could not complete your registration. Try again in a few seconds.",
      "registrationError": "An error occurred while registering. Please try again later.",
      "unregisterConfirm": "Are you sure you want to unregister from this event?",
      "unregisterFailed": "We could not cancel your registration. Try again in a few seconds.",
      "unregisterError": "An error occurred while cancelling your registration. Please try again later.",
      "geolocationNotSupported": "Geolocation not supported",
      "locationNotAvailable": "Location not available",
      "locationAccessDenied": "We could not access your location. Opening Maps with the event destination.",
      "directionsError": "An error occurred while opening directions.",
      "loadAttendeesError": "We could not load the confirmed attendees."
    },
    "readMore": "Lire plus",
    "readLess": "Voir moins",
    "spotsRemaining": "{count} places restantes"
  },
  "calendar": {
    "confirmationTitle": "Registration complete!",
    "confirmationSubtitle": "We look forward to seeing you at {eventTitle}",
    "addToGoogleCalendar": "Add to Google Calendar",
    "addToAppleCalendar": "Add to Apple Calendar",
    "addToCalendar": "Add to calendar",
    "hint": "This will add the event to your calendar. You can edit it later.",
    "downloadICS": "Download .ics file"
  },
  "profile": {
    "loading": "Loading profile...",
    "editPhoto": "Edit profile photo",
    "avatarUpdateError": "Could not save profile photo. Try again.",
    "avatarUploadError": "Could not upload photo. Try again.",
    "avatarCropTitle": "Adjust your photo",
    "avatarCropHint": "Drag and zoom to fit your face inside the circle.",
    "avatarCropZoom": "Zoom",
    "avatarCropCancel": "Cancel",
    "avatarCropSave": "Use photo",
    "avatarCropError": "Could not crop the image. Try again.",
    "avatarCropInvalidType": "Please select a valid image file.",
    "roles": {
      "admin": "Administrator",
      "user": "User"
    },
    "experience": {
      "beginner": "Beginner",
      "intermediate": "Intermediate",
      "advanced": "Advanced",
      "expert": "Expert"
    },
    "whoAmI": {
      "student": "Student",
      "professional": "Professional",
      "entrepreneur": "Entrepreneur",
      "investor": "Investor",
      "mentor": "Mentor",
      "other": "Other"
    },
    "goals": {
      "networking": "Networking",
      "learn": "Learn",
      "opportunities": "Opportunities",
      "mentorship": "Mentorship",
      "collaborate": "Collaborate",
      "share": "Share",
      "personalBrand": "Personal Brand",
      "explore": "Explore"
    },
    "tabs": {
      "aboutMe": "About Me",
      "networking": "Networking",
      "info": "Information",
      "interests": "Interests",
      "social": "Social Networks"
    },
    "completeness": {
      "label": "Profile completed",
      "subtitle": "Complete your profile to get better networking suggestions.",
      "matchHint": "Profiles with more information get better networking matches.",
      "completeProfile": "Complete profile",
      "completeNext": "Complete",
      "allDone": "Profile complete! You'll get the best matches.",
      "personalInfo": "Personal information",
      "interests": "Interests",
      "eventObjective": "Event objective",
      "socialNetworks": "Social networks",
      "professionalExperience": "Professional experience",
      "bio": "Bio",
      "networkingLevel": "Networking Level",
      "hint_personal_info": "Add your name and last name",
      "hint_interests": "Add your professional interests",
      "hint_event_objective": "Set your objective for the event",
      "hint_social_networks": "Add at least one social network",
      "hint_professional_experience": "Set your role and experience level",
      "hint_bio": "Add a short bio about yourself"
    },
    "networking": {
      "title": "Networking",
      "seeking": "Looking to connect with",
      "seekingTagInputPlaceholder": "Type the type of people you want to meet and press Enter (e.g. founders, investors, developers)",
      "offering": "What I offer",
      "offeringTagInputPlaceholder": "Type what you can offer and press Enter (e.g. mentorship, collaboration, hiring)",
      "eventObjective": "Event objective",
      "bioShort": "Bio (max 200 characters)",
      "bioShortPlaceholder": "E.g. Founder building AI products. Interested in meeting developers and investors.",
      "professionalKeywords": "Professional tags",
      "seeking_investors": "Investors",
      "seeking_founders": "Founders",
      "seeking_developers": "Developers",
      "seeking_designers": "Designers",
      "seeking_marketing": "Marketing",
      "seeking_product_managers": "Product Managers",
      "offering_mentorship": "Mentorship",
      "offering_investment": "Investment",
      "offering_collaboration": "Collaboration",
      "offering_hiring": "Hiring talent",
      "offering_finding_partners": "Finding partners",
      "offering_sharing_knowledge": "Sharing knowledge",
      "eventObjective_networking": "Networking",
      "eventObjective_finding_partners": "Finding partners",
      "eventObjective_finding_clients": "Finding clients",
      "eventObjective_investment": "Investment",
      "eventObjective_learning": "Learning",
      "eventObjective_recruiting": "Recruiting talent"
    },
    "matchScore": {
      "title": "Your profile matches with",
      "subtitle": "Complete your profile to improve suggestions.",
      "empty": "Complete your Networking section to see compatibilities.",
      "developersAI": "AI Developers",
      "foundersSaaS": "SaaS Founders",
      "investors": "Investors",
      "developers": "Developers",
      "designers": "Designers",
      "marketing": "Marketing",
      "productManagers": "Product Managers",
      "fintech": "Fintech / Blockchain"
    },
    "aboutMe": {
      "title": "About Me",
      "edit": "Edit",
      "biography": "Biography",
      "biographyPlaceholder": "Describe briefly what you do and who you'd like to meet (e.g. Founder building AI products, interested in meeting developers and investors).",
      "cancel": "Cancel",
      "save": "Save",
      "noBio": "Add a short bio so other attendees can quickly understand who you are.",
      "addBio": "Add bio",
      "whatIDo": "What I Do",
      "noWhatIDo": "Complete this section so others know what you do.",
      "role": "Role",
      "experience": "Experience",
      "goals": "Goals",
      "preferences": "Preferences"
    },
    "personalInfo": {
      "title": "Personal Information",
      "edit": "Edit",
      "firstName": "First name",
      "lastName": "Last name",
      "birthDate": "Date of birth",
      "phone": "Phone",
      "email": "Email",
      "systemRole": "System role",
      "cancel": "Cancel",
      "save": "Save"
    },
    "address": {
      "title": "Address",
      "edit": "Edit",
      "city": "City",
      "cancel": "Cancel",
      "save": "Save"
    },
    "interests": {
      "title": "Interests",
      "edit": "Edit",
      "placeholder": "Innovation, Startups, Design...",
      "tagInputPlaceholder": "Type an interest and press Enter (e.g. AI, Startups, Design)",
      "label": "Interests",
      "cancel": "Cancel",
      "save": "Save",
      "general": "General interests",
      "onboarding": "Onboarding interests",
      "noInterests": "You have not added any interests yet."
    },
    "social": {
      "title": "Social Networks",
      "edit": "Edit",
      "linkedin": "LinkedIn",
      "linkedinPlaceholder": "https://linkedin.com/in/user",
      "twitter": "X (Twitter)",
      "twitterPlaceholder": "https://twitter.com/user",
      "instagram": "Instagram",
      "instagramPlaceholder": "https://instagram.com/user",
      "github": "GitHub",
      "githubPlaceholder": "https://github.com/user",
      "facebook": "Facebook",
      "facebookPlaceholder": "https://facebook.com/user",
      "youtube": "YouTube",
      "youtubePlaceholder": "https://youtube.com/channel",
      "tiktok": "TikTok",
      "tiktokPlaceholder": "https://tiktok.com/@user",
      "website": "Website",
      "websitePlaceholder": "https://my-site.com",
      "cancel": "Cancel",
      "save": "Save",
      "noSocial": "You have not added any social networks yet.",
      "emptyHint": "Add your networks so other attendees can get to know you better.",
      "addSocialNetworks": "Add social networks"
    },
    "errors": {
      "noChanges": "No changes to save.",
      "updateError": "Error: Could not update profile. Try again.",
      "saveError": "Error: An error occurred while saving the profile. Try again.",
      "avatarError": "Error updating avatar"
    }
  },
  "votacion": {
    "title": "Help Us!",
    "subtitle": "Your opinion is very valuable to us. Share your suggestions, ideas and comments to help us improve.",
    "form": {
      "loading": "Loading form...",
      "eventLabel": "Select event",
      "foundErrorsLabel": "Did you find any issues?",
      "yes": "Yes",
      "no": "No",
      "errorDetailsLabel": "If yes, which ones?",
      "errorDetailsPlaceholder": "Tell us what went wrong so we can fix it.",
      "commentLabel": "Anything you want to share about the event? (optional)",
      "commentPlaceholder": "Constructive feedback, what you liked, or anything else you want to share.",
      "submit": "Send feedback",
      "submitting": "Sending feedback..."
    },
    "messages": {
      "profileError": "We couldn't load your profile. Please try again.",
      "selectEventRequired": "Select an event to continue.",
      "selectErrorsRequired": "Please indicate whether you found issues.",
      "errorDetailsRequired": "Please tell us which issues you found.",
      "submitError": "We couldn't send your feedback. Please try again.",
      "submitSuccess": "Thanks for helping us improve. Your feedback was sent successfully.",
      "noEligibleEvents": "You don't have any available events to review yet.",
      "alreadySentForEvent": "You already sent feedback for this event.",
      "pickAnotherEvent": "Choose another event if you want to send more feedback."
    }
  },
  "admin": {
    "title": "Administration",
    "eventos": "Events",
    "usuarios": "Users",
    "organizaciones": "Companies",
    "permisos": "Permissions",
    "rankings": "Rankings",
    "encuentros": "Rencontres",
    "informes": "Reports & Metrics",
    "notificaciones": "Notifications",
    "dashboard": "Dashboard",
    "dashboardTitle": "Dashboard",
    "dashboardSubtitle": "Platform overview",
    "dashboardKpiEvents": "Total events",
    "dashboardKpiUsers": "Total users",
    "dashboardKpiOrganizations": "Companies",
    "dashboardKpiUpcoming": "Upcoming events",
    "dashboardKpiPublished": "Published",
    "dashboardKpiDraft": "Drafts",
    "dashboardKpiPast": "Finished",
    "dashboardKpiCancelled": "Cancelled",
    "dashboardUpcomingEvents": "Upcoming events",
    "dashboardQuickActions": "Quick actions",
    "dashboardViewEvents": "View events",
    "dashboardViewUsers": "View users",
    "dashboardViewOrganizations": "View companies",
    "dashboardViewReports": "View reports",
    "dashboardViewNotifications": "View notifications",
    "dashboardNewEvent": "New event",
    "dashboardNoUpcoming": "No upcoming events",
    "dashboardEventDate": "Date",
    "dashboardLoading": "Loading overview...",
    "nuevoEvento": "New Event",
    "organizacionesTitle": "Companies",
    "organizacionesSubtitle": "Manage platform companies",
    "permisosTitle": "Organizer permissions",
    "permisosSubtitle": "Assign or remove organizer role and associate users to companies",
    "crearOrganizacion": "Create company",
    "crearOrganizacionHint": "The company will be created with your user as owner and organizer.",
    "asignarOrganizador": "Assign as organizer",
    "seleccionarOrganizacion": "Select company",
    "sinOrganizacionesPermisos": "Create a company in the Companies tab to be able to assign.",
    "quitarOrganizador": "Remove organizer role",
    "asociarAOrganizacion": "Associate to organization",
    "nombreOrganizacion": "Name",
    "miembros": "Members",
    "propietario": "Owner",
    "sinOrganizaciones": "No companies",
    "gestionarPermisos": "Gérer les permissions",
    "gestionarEquipo": "Gérer l'équipe",
    "equipoTitle": "Équipe de « {name} »",
    "equipoDescription": "Ajoutez des utilisateurs à cette entreprise. Chaque utilisateur ne peut appartenir qu'à une seule entreprise.",
    "equipoEmpty": "Aucun membre dans cette entreprise",
    "equipoSelectUser": "Sélectionner un utilisateur",
    "equipoSearchUser": "Rechercher par nom ou e-mail…",
    "equipoSearchMin": "Saisissez au moins 2 caractères",
    "equipoSearchEmpty": "Aucun utilisateur trouvé",
    "equipoClearSelection": "Effacer la sélection",
    "equipoAdd": "Ajouter à l'équipe",
    "rolOrganizador": "Organisateur",
    "rolMiembro": "Membre",
    "quitarMiembro": "Retirer",
    "panelScreens": "Écrans du panneau",
    "panelScreensTitle": "Screens visible in organizer panel",
    "panelScreensDescription": "Enable or disable sections that organizers of this company will see.",
    "panelScreenDashboard": "Dashboard",
    "panelScreenEvents": "Events",
    "panelScreenAttendees": "Attendees",
    "panelScreenNetworking": "Networking",
    "panelScreenAnalytics": "Analytics",
    "panelScreenNotifications": "Notifications",
    "panelScreenSettings": "Organization settings",
    "eliminarEmpresa": "Delete company",
    "confirmarEliminarEmpresa": "Delete company",
    "confirmarEliminarEmpresaHint": "Delete the company «{name}»? Members will be removed and events will have no company assigned.",
    "panelScreensSave": "Save screens",
    "panelScreensAll": "All",
    "eventosSubtitle": "Manage all platform events",
    "usuariosSubtitle": "Manage users and permissions",
    "rankingsSubtitle": "User rankings by connections and activity",
    "encuentrosSubtitle": "Rencontres en personne confirmées par QR entre utilisateurs connectés",
    "meetups": {
      "loading": "Chargement des rencontres…",
      "kpiTotal": "Total confirmées",
      "kpi24h": "Dernières 24 h",
      "kpi7d": "7 derniers jours",
      "searchPlaceholder": "Rechercher par nom ou e-mail…",
      "empty": "Aucune rencontre confirmée par QR pour le moment",
      "emptyHint": "Lorsque deux utilisateurs confirment une rencontre en personne, elle apparaîtra ici.",
      "noSearchResults": "Aucun résultat",
      "noSearchResultsHint": "Essayez un autre nom ou e-mail.",
      "colUserA": "Utilisateur A",
      "colUserB": "Utilisateur B",
      "colDate": "Date",
      "colMethod": "Méthode",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "informesSubtitle": "Real-time metrics for upcoming events and full reports for past events",
    "notificacionesSubtitle": "Send notifications to all users or selected users",
    "filterOptions": "Filter options",
    "filterAll": "All",
    "filterUpcoming": "Upcoming",
    "filterPast": "Past",
    "filterCancelled": "Cancelled",
    "filterAdmins": "Admins",
    "filterUsers": "Users",
    "rankingByConnections": "By total connections",
    "rankingMostConnected": "Most connected",
    "rankingByConnectionsTitle": "Ranking by connections",
    "rankingMostConnectedTitle": "Most connected users",
    "rankingType": "Ranking type",
    "tableTitle": "Title",
    "tableDate": "Date",
    "tableLocation": "Location",
    "tableStatus": "Status",
    "tableActions": "Actions",
    "tableName": "Name",
    "tableEmail": "Email",
    "tableRole": "Role",
    "tableOrganizer": "Organizer",
    "tablePosition": "Position",
    "tableSent": "Sent",
    "tableReceived": "Received",
    "tableAccepted": "Accepted",
    "tableTotal": "Total",
    "tableConnections": "Connections",
    "tableUser": "User",
    "statusUpcoming": "Upcoming",
    "statusPast": "Past",
    "statusCancelled": "Cancelled",
    "roleAdmin": "Admin",
    "roleUser": "User",
    "loading": "Loading...",
    "loadingEvents": "Loading events...",
    "loadingUsers": "Loading users...",
    "loadingRankings": "Loading rankings...",
    "noEvents": "No events",
    "noUsers": "No users",
    "noRankings": "No ranking data available",
    "makeAdmin": "Make Admin",
    "removeAdmin": "Remove Admin",
    "eventsCount": "Events",
    "usersCount": "Users",
    "confirmDeleteEvent": "Are you sure you want to delete the event \"{title}\"? This action cannot be undone.",
    "roleUpdated": "Role updated successfully",
    "roleUpdateError": "Could not update role",
    "eventDeleted": "Event deleted successfully",
    "eventDeleteError": "Could not delete event",
    "orgCreated": "Organization created successfully",
    "orgCreateError": "Could not create organization",
    "dashboardTodayBanner": "{count} events start TODAY",
    "dashboardPlatformHealth": "Platform Health",
    "dashboardHealthNewUsers": "New users (7 days)",
    "dashboardHealthPublishedEvents": "Published events",
    "dashboardHealthNewOrgs": "New companies (7 days)",
    "dashboardDraftPastSummary": "{draft} drafts · {past} completed",
    "dashboardBadgeLive": "LIVE",
    "dashboardBadgeScheduled": "SCHEDULED",
    "dashboardViewAllUpcoming": "View all ({count}) →",
    "dashboardNewOrganization": "New Company",
    "dashboardViewPermissions": "View Permissions"
  },
  "organizer": {
    "title": "Organizer panel",
    "dashboard": "Dashboard",
    "events": "Events",
    "attendees": "Attendees",
    "networking": "Networking",
    "analytics": "Analytics",
    "notifications": "Notifications",
    "settings": "Organization settings",
    "loading": "Loading...",
    "selectEvent": "Select an event",
    "noData": "No data",
    "noDataDescription": "Could not load data.",
    "dashboardTitle": "Dashboard",
    "dashboardDescription": "Overview of your events and metrics. Select a section from the menu to get started.",
    "dashboardLoading": "Loading summary...",
    "dashboardKpiTotalEvents": "Total events",
    "dashboardKpiDraft": "Drafts",
    "dashboardKpiPublished": "Published",
    "dashboardKpiPast": "Past",
    "dashboardKpiCancelled": "Cancelled",
    "dashboardKpiTotalAttendees": "Registered attendees",
    "dashboardKpiTotalActiveAttendees": "Active attendees",
    "dashboardNoPublishedHint": "You don't have any published events yet. Publish one to see metrics.",
    "dashboardKpiTotalConnections": "Connections generated",
    "dashboardKpiTotalMessages": "Messages sent",
    "dashboardKpiAvgConnections": "Connections per event (avg)",
    "dashboardKpiAvgProfile": "Profile completed (avg)",
    "dashboardUpcomingEvents": "Upcoming events",
    "dashboardNoUpcoming": "No upcoming events",
    "dashboardNoUpcomingDescription": "Publish an event to see it here.",
    "dashboardTopNetworking": "Top networking events",
    "dashboardTopNetworkingConnections": "connections",
    "dashboardNoNetworking": "No networking data",
    "dashboardNoNetworkingDescription": "When your events generate connections, they will appear here.",
    "dashboardCreateEvent": "Create event",
    "dashboardViewAnalytics": "View analytics",
    "dashboardViewEvents": "View events",
    "dashboardEmptyTitle": "No events yet",
    "dashboardEmptyDescription": "Create your first event to start seeing metrics and statistics.",
    "dashboardEventDate": "Date",
    "dashboardEventAttendees": "attendees",
    "eventsTitle": "Events",
    "eventsNew": "New event",
    "eventsFilterStatus": "Status:",
    "eventsFilterAll": "All",
    "eventsFilterPublished": "Published",
    "eventsFilterDraft": "Draft",
    "eventsFilterPast": "Past",
    "eventsFilterCancelled": "Cancelled",
    "eventsFilterUpcoming": "Upcoming",
    "eventsFilterDate": "Date:",
    "eventsTableLocation": "Location",
    "eventsStatusPublished": "Published",
    "eventsStatusDraft": "Draft",
    "eventsStatusArchived": "Archived",
    "eventsStatusCancelled": "Cancelled",
    "eventsTableTitle": "Title",
    "eventsTableDate": "Date",
    "eventsTableStatus": "Status",
    "eventsTableCapacity": "Capacity",
    "eventsTableActions": "Actions",
    "eventsEdit": "Edit",
    "eventsCopyLink": "Copy link",
    "eventsLinkCopied": "Link copied",
    "eventsLanding": "Landing",
    "eventsPublish": "Publish",
    "eventsUnpublish": "Unpublish",
    "eventsArchive": "Archive",
    "eventsCancel": "Cancel event",
    "eventsNoEvents": "No events",
    "eventsNoEventsDescription": "Create your first event to get started.",
    "eventsNoCapacity": "No limit",
    "eventNewTitle": "New event",
    "eventNewNoOrg": "You need to belong to an organization to create events. Create an organization first or ask to be added as org_admin.",
    "eventNewBackToEvents": "Back to Events",
    "eventEditTitle": "Edit event",
    "attendeesTitle": "Attendees",
    "attendeesSendNotification": "Send notification",
    "attendeesNoAttendees": "No attendees",
    "attendeesNoAttendeesDescription": "No one has registered for this event yet.",
    "attendeesLoading": "Loading attendees...",
    "attendeesTableName": "Name",
    "attendeesTableEmail": "Email",
    "attendeesTableStatus": "Status",
    "attendeesTableDate": "Registration date",
    "attendeesTableProfile": "Profile",
    "networkingTitle": "Networking",
    "networkingLoading": "Loading metrics...",
    "networkingSentRequests": "Requests sent",
    "networkingAcceptedRequests": "Requests accepted",
    "networkingTotalConnections": "Total connections",
    "networkingAcceptanceRatio": "Acceptance ratio",
    "networkingTopConnectors": "Top connectors",
    "networkingNoData": "No data",
    "networkingNoDataDescription": "No connections between attendees yet.",
    "networkingNoDataGeneric": "Could not load metrics.",
    "networkingConnections": "connections",
    "networkingAttendeesCount": "Registered attendees",
    "networkingHintLowEngagement": "Only some attendees have made connections.",
    "networkingHintCta": "Send a notification to encourage networking",
    "analyticsTitle": "Analytics",
    "analyticsLoading": "Loading analytics...",
    "analyticsRegistered": "Registered",
    "analyticsActive": "Active",
    "analyticsActiveHelp": "Registrants marked as «attending» (check-in during the event)",
    "analyticsTotalAttendedHelp": "Registrants marked as «attended» after the event",
    "analyticsRegisteredHelp": "Only people who clicked «Register» for this event in the app (not all users with an account)",
    "analyticsProfileComplete": "% Profile complete",
    "analyticsSentRequests": "Requests sent",
    "analyticsAcceptedRequests": "Requests accepted",
    "analyticsTotalConnections": "Total connections",
    "analyticsAcceptanceRatio": "Acceptance ratio",
    "analyticsMessagesSent": "Messages sent",
    "analyticsActiveConversations": "Conversations actives",
    "analyticsActiveConversationsHelp": "Discussions avec au moins un message (MP entre participants + chat de l'événement)",
    "analyticsConnectionsPerAttendee": "Connections per attendee (avg)",
    "analyticsFunnel": "Funnel",
    "analyticsRegistrationsByDay": "Registrations by day",
    "analyticsDate": "Date",
    "analyticsRegistrations": "Registrations",
    "analyticsTopInterests": "Top interests",
    "analyticsTopGoals": "Top goals",
    "analyticsShareableSummary": "Shareable summary",
    "meetups": {
      "sectionTitle": "Rencontres confirmées",
      "kpiTotal": "Total",
      "kpi24h": "Dernières 24 h",
      "kpi7d": "Derniers 7 jours",
      "empty": "Aucune rencontre confirmée",
      "emptyHint": "Ici figurent les rencontres en personne confirmées par les participants de cet événement via le QR à usage unique.",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "analyticsCopyClipboard": "Copy to clipboard",
    "analyticsCopied": "Copied",
    "analyticsNoData": "No data",
    "analyticsNoDataDescription": "Could not load metrics for this event.",
    "analyticsFilterAll": "All",
    "analyticsFilterUpcoming": "Upcoming",
    "analyticsFilterPast": "Past",
    "analyticsEventHeaderViewEvent": "View event",
    "analyticsEventHeaderCopyLink": "Copy link",
    "analyticsEventHeaderViewAttendees": "View attendees",
    "analyticsEventHeaderSendNotification": "Send notification",
    "analyticsStatusUpcoming": "Upcoming",
    "analyticsStatusOngoing": "Ongoing",
    "analyticsStatusPast": "Past",
    "analyticsStatusCancelled": "Cancelled",
    "analyticsSectionAttendance": "Attendance and registration",
    "analyticsSectionNetworking": "Networking and engagement",
    "analyticsSectionFunnel": "Participation funnel",
    "analyticsSectionSummary": "Shareable summary",
    "analyticsLastUpdate": "Last update",
    "analyticsEmptyNoEvents": "You don't have any events yet",
    "analyticsEmptyNoEventsDescription": "Create your first event to see analytics.",
    "analyticsEmptyNoRegistrations": "No one has registered for this event yet.",
    "analyticsEmptyNoNetworkingTitle": "No networking activity yet",
    "analyticsEmptyNoNetworkingCta": "Send a notification to activate networking among attendees.",
    "analyticsMetricUnavailable": "No data yet",
    "analyticsCopySummary": "Copy summary",
    "analyticsFunnelRegistered": "Registered",
    "analyticsFunnelProfileComplete": "Profile complete",
    "analyticsFunnelSentRequest": "Sent request",
    "analyticsFunnelConnected": "Connected",
    "analyticsFunnelChatted": "Chatted",
    "analyticsTotalRegistered": "Total registered",
    "analyticsTotalAttended": "Total attended",
    "analyticsAttendanceRate": "Attendance rate",
    "analyticsCancelled": "Cancelled",
    "analyticsSelectEventPlaceholder": "Select event",
    "analyticsEmptySelectEvent": "Select an event to see metrics",
    "notificationsTitle": "Notifications",
    "notificationsSendToAttendees": "Send to event attendees",
    "notificationsTitlePlaceholder": "Title",
    "notificationsMessagePlaceholder": "Message",
    "notificationsSend": "Send",
    "notificationsSending": "Sending...",
    "notificationsHistory": "Campaign history",
    "notificationsNoCampaigns": "No campaigns",
    "notificationsNoCampaignsDescription": "You haven't sent any notifications to this event yet.",
    "settingsPageTitle": "Settings",
    "settingsOrgSection": "Organization",
    "settingsOrgName": "Organization name",
    "settingsTeamSection": "Team",
    "settingsTeamRoleAdmin": "Admin",
    "settingsTeamRoleMember": "Member",
    "settingsTeamRemove": "Remove from team",
    "settingsRemoveConfirm": "Remove this user from the team?",
    "settingsTeamOwner": "owner",
    "settingsTableName": "Name",
    "settingsTableEmail": "Email",
    "settingsTableRole": "Role",
    "settingsSave": "Save",
    "settingsSaved": "Saved",
    "settingsLoading": "Loading…",
    "settingsNoOrg": "You don't have any organization. Create one from the admin panel.",
    "brandingSectionTitle": "Company branding",
    "brandingSectionDesc": "Logo and colors applied to your organization's events.",
    "brandingLogoLabel": "Logo",
    "brandingLogoHint": "Drag an image or click (max. 2 MB)",
    "brandingLogoUpload": "Upload logo",
    "brandingLogoRemove": "Remove logo",
    "brandingUploading": "Uploading…",
    "brandingPrimary": "Primary color",
    "brandingSecondary": "Secondary color",
    "brandingContrastWarning": "Secondary color may have low contrast with white text on badges.",
    "brandingPreviewLabel": "Live preview",
    "brandingSaved": "Branding saved",
    "brandingSaveError": "Could not save branding",
    "brandingUploadError": "Failed to upload logo",
    "plataforma": "Platform",
    "dashboardKpiRegistered": "Total registered",
    "dashboardKpiAttendance": "Attendance",
    "dashboardKpiEngagement": "Engagement",
    "dashboardTrendThisWeek": "this week",
    "dashboardNextActions": "Next actions",
    "dashboardActionEventsWeek": "{count} events start this week",
    "dashboardActionPendingCheckIn": "{count} registered without confirmed check-in",
    "dashboardActionConnections": "Review new connections in Networking",
    "dashboardMyEvents": "My events",
    "dashboardAttendeesShort": "registered",
    "dashboardBadgeLive": "LIVE",
    "dashboardBadgeScheduled": "Scheduled",
    "dashboardQuickActionsTitle": "Actions",
    "dashboardViewAttendees": "View attendees",
    "dashboardSendNotification": "Send notification",
    "dashboardQuickAnalytics": "Quick analytics",
    "dashboardExportCsv": "Export CSV",
    "dashboardCreateEventShort": "+ Create event",
    "dashboardViewAllEvents": "View all ({count})"
  },
  "panel": {
    "title": "Panel",
    "admin": "Admin panel",
    "organizer": "Organizer panel",
    "desktopOnly": {
      "title": "Disponible sur tablette et ordinateur",
      "description": "Les panneaux d’administration et d’organisateur sont conçus pour les grands écrans. Ouvrez-les depuis une tablette ou un ordinateur.",
      "backToEvents": "Retour aux événements"
    }
  },
  "navigation": {
    "eventos": "Events",
    "chats": "Chats",
    "perfil": "Profile",
    "ajustes": "Settings",
    "votacion": "Help Us!",
    "quienesSomos": "About Us",
    "actividad": "Activity",
    "closeMenu": "Close menu",
    "panel": "Panel",
    "panelAdmin": "Admin panel",
    "panelOrganizer": "Organizer panel"
  },
  "chats": {
    "title": "Chats",
    "activity": {
      "feedTitle": "Activity",
      "feedSubtitle": "Requests, messages and connections",
      "markAllRead": "Mark all as read",
      "error": "Could not load activity.",
      "retry": "Retry",
      "empty": "You have no activity yet",
      "emptyHint": "Connection requests, acceptances and messages will appear here.",
      "exploreEvents": "Explore events",
      "someone": "Someone",
      "newMessage": "New message",
      "sentRequest": "sent you a request",
      "requestSent": "Request sent",
      "requestAccepted": "accepted your request"
    },
    "recentActivity": "Your recent activity",
    "loading": "Loading...",
    "noChats": "You don't have any chats yet",
    "noChatsHint": "Register for an event to connect and chat with more people",
    "tabs": {
      "activity": "Activity",
      "connections": "Connections",
      "chats": "Chats"
    },
    "requests": {
      "title": "Requests",
      "allContacts": "All your contacts",
      "favorites": "Favorites",
      "sent": {
        "title": "Sent Requests",
        "pending": "pending request",
        "pendingPlural": "pending requests",
        "waiting": "Waiting for response",
        "cancel": "Cancel"
      },
      "received": {
        "title": "Connection Requests",
        "pending": "pending request",
        "pendingPlural": "pending requests",
        "wantsToConnect": "Wants to connect with you",
        "accept": "Accept",
        "reject": "Reject",
        "noPending": "No pending requests"
      }
    },
    "contacts": {
      "noContacts": "You have no connected contacts",
      "noContactsHint": "Connect with other users to see them here",
      "removeFavorite": "Remove from favorites",
      "addFavorite": "Add to favorites",
      "openChat": "Open chat",
      "noFavorites": "You have no favorite contacts",
      "noFavoritesHint": "Mark contacts as favorites to see them here"
    },
    "connections": {
      "acceptSuccessTitle": "Connection accepted",
      "acceptSuccessMessage": "You can now chat with this contact.",
      "acceptErrorMessage": "Could not accept the request.",
      "rejectSuccessTitle": "Request rejected",
      "rejectSuccessMessage": "You have rejected the connection request.",
      "rejectErrorMessage": "Could not reject the request.",
      "cancelSuccessTitle": "Request cancelled",
      "cancelSuccessMessage": "You have cancelled the connection request.",
      "cancelErrorMessage": "Could not cancel the request.",
      "viewRequests": "View requests",
      "dmBlockedTitle": "Connection required",
      "dmBlockedMessage": "Accept the connection request to chat.",
      "alreadyPending": "There is already a pending request between you.",
      "alreadyConnected": "You are already connected.",
      "cooldownActive": "Wait a moment before sending the request again.",
      "rateLimited": "Too many requests. Wait a moment and try again."
    },
    "search": "Search or start new chat",
    "noRecentChats": "No recent chats",
    "selectChat": "Select a chat",
    "selectChatHint": "Choose a conversation from the list to start chatting",
    "dm": {
      "deleteError": "Impossible de supprimer le chat. Réessaie.",
      "deleteChat": "Supprimer le chat",
      "deleting": "Suppression..."
    }
  },
  "eventWizard": {
    "progressAria": "Wizard progress",
    "stepMeta": "Étape {current} sur {total}",
    "sections": {
      "identity": "Identité de l'événement",
      "visibility": "Visibilité",
      "configuration": "Configuration",
      "storytelling": "Storytelling",
      "when": "Quand",
      "formatAndPlace": "Format et lieu",
      "arrival": "Arrivée",
      "speakers": "Intervenants",
      "agenda": "Agenda",
      "branding": "Branding",
      "review": "Résumé",
      "discovery": "Découverte"
    },
    "steps": {
      "basic": "Basics",
      "location": "Location",
      "speakers": "Speakers",
      "agenda": "Agenda",
      "style": "Style",
      "review": "Review"
    },
    "nav": {
      "prev": "Back",
      "next": "Next",
      "cancel": "Cancel",
      "draft": "Save draft",
      "publish": "Create event",
      "saveChanges": "Save changes",
      "saving": "Saving..."
    },
    "loading": "Loading event data...",
    "previewLive": "Live preview",
    "previewPlatform": "Platform preview",
    "edit": "Edit",
    "step1": {
      "title": "The essentials of your event",
      "description": "Give your event an attractive title, an inspiring description, and choose its type.",
      "titleLabel": "Event title",
      "titlePlaceholder": "E.g. Biavent Networking Night Madrid",
      "titleHint": "Be clear and descriptive. A good title grabs your target audience instantly.",
      "visibilityLabel": "Public or private?",
      "visibilityPublic": "Public",
      "visibilityPrivate": "Private",
      "categoryLabel": "Main category",
      "eventTypeLabel": "Event type",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Describe what attendees will learn, why your event is unique, and who it is for...",
      "highlightLabel": "Highlight quote",
      "highlightPlaceholder": "E.g. 'The biggest meetup for developers and investors of the year.'",
      "highlightHint": "A short, powerful phrase highlighted on the event landing page.",
      "tipTitle": "💡 Biavent tip",
      "tipText": "85% of registrations are driven by a structured description and a concise title. Define your target audience well!"
    },
    "step2": {
      "title": "Location and date",
      "description": "Set the date, time, and whether the event is in person or online.",
      "dateLabel": "Date",
      "timeLabel": "Time",
      "timePlaceholder": "E.g. 7:00 PM - 10:00 PM",
      "timezoneLabel": "Timezone",
      "locationLabel": "Location or link",
      "locationOnlineLabel": "Streaming link",
      "locationPlaceholder": "Street, city or link",
      "locationOnlinePlaceholder": "Zoom, Meet, YouTube...",
      "formatLabel": "Online or in person?",
      "formatInPerson": "In person",
      "formatOnline": "Online",
      "formatHybrid": "Hybrid",
      "mapButton": "Map",
      "venueLabel": "Venue name",
      "venuePlaceholder": "E.g. Main auditorium, Tech campus...",
      "arrivalLabel": "Additional arrival instructions",
      "arrivalPlaceholder": "Access, parking, floor, etc.",
      "mapsPreviewEmpty": "Enter an address to see the map preview",
      "capacityLabel": "Capacity limit",
      "capacityPlaceholder": "E.g. 100 — leave empty for unlimited",
      "capacityHint": "When capacity is reached, new registrations will be blocked automatically.",
      "latLabel": "Latitude (optional)",
      "lngLabel": "Longitude (optional)",
      "latPlaceholder": "E.g. 40.4167",
      "lngPlaceholder": "E.g. -3.7037"
    },
    "step3": {
      "title": "Your speakers",
      "description": "Introduce the speakers leading your sessions. Add role, bio, and photo.",
      "emptyTitle": "No speakers yet",
      "emptyText": "Will your event have speakers? Add them below. For informal networking you can skip this step.",
      "addSpeaker": "Add speaker",
      "nameLabel": "Name",
      "roleLabel": "Role",
      "bioLabel": "Short bio",
      "bioPlaceholder": "Short biography...",
      "avatarLabel": "Photo (URL)",
      "avatarPlaceholder": "https://...",
      "dragTitle": "Drag to reorder",
      "avatarUpload": "Upload photo",
      "avatarUploading": "Uploading...",
      "deleteSpeaker": "Remove"
    },
    "step4": {
      "title": "Program and agenda",
      "description": "Describe activities step by step so attendees can plan their day.",
      "emptyTitle": "Empty agenda",
      "emptyText": "Click «Add slot» to add activities (reception, talks, networking, etc.).",
      "addSlot": "Add slot",
      "startLabel": "Début",
      "endLabel": "Fin",
      "activityLabel": "Activité",
      "deleteSlot": "Supprimer le créneau",
      "slotTitlePlaceholder": "Networking, talk...",
      "activityFallback": "Activity"
    },
    "step5": {
      "title": "Style and branding",
      "description": "Upload cover images, logos, and choose colors for cards and buttons.",
      "bannerLabel": "Cover / banner image",
      "bannerUpload": "Upload main image (1200×630)",
      "bannerUploading": "Uploading image...",
      "bannerRemove": "Remove cover",
      "bannerUrlHint": "Or paste an image URL:",
      "logoLabel": "Company / organizer logo",
      "logoUpload": "Upload logo",
      "logoUploading": "Uploading logo...",
      "logoRemove": "Remove logo",
      "logoUrlHint": "Or paste logo URL:",
      "typographyLabel": "Typography",
      "paletteLabel": "Event color palette",
      "paletteHint": "Pick a brand combination or customize the accent color.",
      "primaryColor": "Primary color",
      "accentColor": "Accent color (buttons)",
      "previewBadge": "UPCOMING",
      "previewCtaFallback": "Register"
    },
    "step6": {
      "title": "Review and publish",
      "description": "Add contact info, social links, and preview your landing before saving.",
      "websiteLabel": "Official website",
      "emailLabel": "Contact email",
      "mapsLabel": "Google Maps link",
      "socialLabel": "Social media (optional)",
      "ctaLabel": "Call-to-action button text",
      "ctaPlaceholder": "E.g. Register for the event",
      "ctaHint": "Text shown on the main registration button.",
      "reviewBasic": "Basics",
      "reviewLocation": "Location",
      "reviewSpeakers": "Speakers",
      "reviewAgenda": "Agenda",
      "reviewStyle": "Style",
      "noTitle": "No title",
      "toDefine": "To be defined",
      "speakersCount": "{{count}} speakers",
      "agendaCount": "{{count}} slots",
      "visualIdentity": "Visual identity",
      "withCover": "With cover",
      "withoutCover": "No cover"
    },
    "eventNew": {
      "title": "Create new event",
      "subtitle": "Follow the steps to publish on Biavent. It will be saved as a draft until you publish."
    },
    "errors": {
      "fixBeforeContinue": "Fix the errors before continuing to the next step.",
      "loadEvent": "Error loading event",
      "titleRequiredSave": "Please enter a title for your event",
      "fixStepBeforePublish": "Please fix the fields in Step {{step}} before publishing.",
      "invalidImage": "Please select a valid image file (png, jpg, jpeg)",
      "imageTooLarge": "Image size cannot exceed 5 MB",
      "uploadFailed": "Error uploading image",
      "draftUpdated": "Draft updated successfully",
      "eventUpdated": "Event updated successfully",
      "draftSaved": "Draft saved. You can edit and publish it later",
      "eventCreated": "Congratulations! The event was created successfully",
      "saveFailed": "Error saving"
    },
    "accordion": {
      "advancedLocation": "Advanced location",
      "capacity": "Capacity",
      "contact": "Contact and social (optional)"
    },
    "font": {
      "system": "System (default)",
      "serif": "Classic serif",
      "modern": "Modern sans"
    },
    "social": {
      "linkedinPlaceholder": "Your company LinkedIn URL",
      "twitterPlaceholder": "Twitter / X URL",
      "instagramPlaceholder": "Instagram URL"
    }
  },
  "dashboardPremium": {
    "greeting": "Welcome back, {name}",
    "contextSummary": "You have {events} events this week and {pending} pending to publish",
    "searchPlaceholder": "Search events…",
    "createEvent": "Create event",
    "viewAnalytics": "Analytics",
    "trendVsPrevious": "vs previous period",
    "kpiActiveEvents": "Active events",
    "kpiActiveEventsFooter": "{scheduled} scheduled · {live} live now",
    "kpiUsers": "Registered users",
    "kpiUsersFooter": "+{new} new this period",
    "kpiOrganizations": "Partner companies",
    "kpiOrgsFooter": "+{new} new this period",
    "kpiConversion": "Conversion",
    "kpiConversionFooter": "Registrations / users",
    "activityTitle": "Activity summary",
    "range7d": "7D",
    "range30d": "30D",
    "range90d": "90D",
    "seriesRegistrations": "Registrations",
    "seriesPublications": "Publications",
    "seriesConnections": "Connections",
    "chartEmpty": "No activity in this period yet",
    "upcomingTitle": "Upcoming events",
    "noUpcoming": "No upcoming events",
    "emptyUpcomingHint": "Créez un événement pour le voir ici une fois programmé.",
    "badgeLive": "LIVE",
    "badgeScheduled": "SCHEDULED",
    "badgeDraft": "DRAFT",
    "editEvent": "Edit",
    "viewAllUpcoming": "View all ({count}) →",
    "quickActionsTitle": "Quick actions",
    "performanceTitle": "Recent performance",
    "perfTopRegistrations": "Top registrations",
    "perfLowAttendance": "Lowest attendance",
    "perfTopOrgs": "Most active companies",
    "perfPendingTasks": "Pending tasks",
    "perfEmpty": "No data yet",
    "perfTasksEmpty": "No pending tasks",
    "taskDrafts": "{count} draft events",
    "taskUnpublished": "{count} upcoming drafts",
    "growthTitle": "Growth tips",
    "aiLabel": "AI recommendation",
    "growthTipDrafts": "Draft events don't generate registrations until you publish them.",
    "growthRecDrafts": "You have {count} draft(s). Publish at least one to start capturing attendees.",
    "growthTipCover": "Events with a professional cover image tend to convert better.",
    "growthRecCover": "Events with a cover image convert up to {percent}% better on average.",
    "growthTipAttendance": "Attendance is below your platform average.",
    "growthRecAttendance": "Current attendance rate is {rate}%. Send reminders before the event starts.",
    "growthTipDefault": "Keep publishing and engaging attendees after each event.",
    "growthRecDefault": "Review analytics after each event to double down on what works.",
    "feedTitle": "Recent activity",
    "feedEmpty": "No recent activity",
    "feedRegistration": "New registration",
    "feedPlatform": "Platform",
    "feedPublished": "Event published",
    "feedNewOrg": "New company",
    "loadError": "Could not load dashboard",
    "actionNewEventDesc": "Launch a new event in minutes",
    "actionNewOrgDesc": "Onboard a new partner company",
    "actionUsersDesc": "Manage users and roles",
    "actionPermissionsDesc": "Organizers and access",
    "actionNotificationsDesc": "Reach your audience",
    "actionAttendeesDesc": "Registrations and check-in",
    "actionAnalyticsDesc": "Networking and engagement",
    "actionExportDesc": "Export attendee data",
    "headerStatEventsWeek": "events this week",
    "headerStatPending": "pending to publish"
  },
  "notFound": {
    "title": "Page introuvable",
    "message": "La page recherchée n’existe pas ou n’est plus disponible.",
    "goHome": "Aller aux événements",
    "errorTitle": "Page introuvable",
    "errorMessage": "Impossible de charger cette vue.",
    "reload": "Recharger l’app"
  },
  "meetingQr": {
    "confirmTitle": "Confirmer la rencontre",
    "confirmWith": "Avec {name}",
    "confirmCta": "Confirmer la rencontre",
    "scanCta": "Scanner le QR",
    "scanTitle": "Scanner le QR de rencontre",
    "scanInstruction": "Pointez la caméra vers le QR affiché par l'autre personne.",
    "scanHint": "Demandez à l'autre personne de scanner ce QR depuis Connexions → Scanner le QR.",
    "generating": "Génération du QR sécurisé…",
    "expiresIn": "Expire dans {time}",
    "confirmed": "Rencontre confirmée !",
    "expired": "Ce QR a expiré",
    "generateAgain": "Générer un nouveau QR",
    "verifying": "Vérification…",
    "scanAgain": "Scanner à nouveau",
    "back": "Retour",
    "badgeConfirmed": "Rencontre confirmée",
    "errors": {
      "generic": "Une erreur s'est produite. Réessayez.",
      "invalid": "QR invalide",
      "expired": "Ce QR a expiré",
      "alreadyUsed": "Ce QR a déjà été utilisé",
      "notTarget": "Ce QR n'est pas destiné à vous",
      "self": "Vous ne pouvez pas confirmer une rencontre avec vous-même",
      "noConnection": "Vous devez d'abord être connectés",
      "alreadyConfirmed": "Rencontre déjà confirmée",
      "noPriorChat": "Vous devez avoir échangé des messages d'abord",
      "rateLimited": "Trop de tentatives. Patientez un instant.",
      "camera": "Impossible d'accéder à la caméra. Vérifiez les permissions.",
      "cameraDenied": "Permission caméra refusée",
      "cameraUnavailable": "Aucune caméra trouvée sur cet appareil",
      "cameraInsecure": "La caméra nécessite une connexion sécurisée (HTTPS)"
    },
    "cameraPermissionTitle": "Accès à la caméra requis",
    "cameraPermissionBody": "Pour scanner le QR de rencontre, Biavent a besoin d’accéder à votre caméra. Appuyez sur le bouton pour l’autoriser.",
    "allowCamera": "Autoriser la caméra et scanner",
    "requestingCamera": "Demande d’accès à la caméra…",
    "cameraDeniedHint": "L’accès à la caméra est bloqué. Autorisez la caméra pour Biavent dans les réglages du navigateur ou du téléphone, puis réessayez.",
    "tryAgain": "Réessayer"
  }
}
